// tslint:disable:no-any

export default (state: any = [], action: any) => {
    switch (action.type) {
        case 'LOAD_SHARED_DIVES_SUCCESS':
            if (action.dives === undefined) {
                return [];
            }
            return action.dives;
        case 'REMOVE_SHARED_DIVE_SUCCESS':
            return state.filter(
                (_: any, index: any) => action.diveIndex !== index
            );
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/sharedDivesReducer.ts